// extracted by mini-css-extract-plugin
export var base = "_1l-0";
export var updateBanner = "_1l-1";